import { render, staticRenderFns } from "./LsDismissibleNotice.vue?vue&type=template&id=c8588c42&scoped=true&"
import script from "./LsDismissibleNotice.vue?vue&type=script&lang=js&"
export * from "./LsDismissibleNotice.vue?vue&type=script&lang=js&"
import style0 from "./LsDismissibleNotice.vue?vue&type=style&index=0&id=c8588c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8588c42",
  null
  
)

export default component.exports